export default __webpack_public_path__ + "58237dcee4c972cbbb78e6ad5022af1e.svg";